import React from "react";
import Typable from "shared/components/oknf/_Typable";

const OkTextarea = React.forwardRef((props, ref) => (
	<Typable ref={ref} {...props} type="textarea" />
));

export default OkTextarea;



// WEBPACK FOOTER //
// ./src/shared/components/oknf/OkTextarea.jsx